export default "__VITE_ASSET__Dv3_GG0F__"